import { autoinject, customAttribute, delegationStrategy } from 'aurelia-framework';
import { watch } from 'aurelia-watch-decorator';
import { TaskMutex } from 'framework/script_utilities/task-executor';

@autoinject
@customAttribute('af-mutex-delegate')
export class MutexDelegateCustomAttribute {
  private element: HTMLButtonElement;
  private binding;
  private callSource;

  constructor(element: Element, private mutex: TaskMutex) {
    this.element = element as HTMLButtonElement;
  }

  created(owningView) {
    this.binding = owningView.bindings.find(b => b.constructor.name === 'Listener' && b.target === this.element && b.delegationStrategy === delegationStrategy.bubbling);
  }

  attached() {
    if (this.binding) {
      this.element.classList.add(CLASS_GROUP);
      this.callSource = this.binding.callSource;
      this.binding.callSource = (event) => this.mutex.executeIfNotRunning(() => this.styledCall(() => this.callSource.call(this.binding, event)));
    }
  }

  detached() {
    if (this.binding) {
      this.binding.callSource = this.callSource;
      this.element.classList.remove(CLASS_GROUP, CLASS_EXECUTING, CLASS_DISABLED);
    }
  }

  async styledCall(handler: () => unknown) {
    try { this.element.classList.add(CLASS_EXECUTING); return await handler(); }
    finally { this.element.classList.remove(CLASS_EXECUTING); }
  }

  @watch((x: MutexDelegateCustomAttribute) => x.mutex.isRunning)
  private mutexChanged(isRunning: boolean) {
    isRunning
      ? this.element.classList.add(CLASS_DISABLED)
      : this.element.classList.remove(CLASS_DISABLED);
  }
}

const CLASS_GROUP = 'af-mutex';
const CLASS_EXECUTING = 'af-mutex--executing';
const CLASS_DISABLED = 'af-mutex--disabled';
